import { render } from "./InclusionnDiversity.vue?vue&type=template&id=1bce0714&scoped=true"
import script from "./InclusionnDiversity.vue?vue&type=script&lang=js"
export * from "./InclusionnDiversity.vue?vue&type=script&lang=js"

import "./InclusionnDiversity.vue?vue&type=style&index=0&id=1bce0714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bce0714"]])

export default __exports__